module.exports = __webpack_public_path__ + "assets/bubble-chat-heart.b54db43cec730d8e6512c8c5bb776d6e.svg";